import React, { useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { GET_TAXPAYER_LIST } from '../constant';
import { getTaxPayerList } from '../action';

const selectList = ({ api }) => {
  return _.get(api, `${GET_TAXPAYER_LIST}.list`) || [];
};

const formatOptions = data => {
  return data.map(item => {
    let finalLabel = '';
    if (
      !_.isEmpty(_.get(item, 'attributes.mobile_number')) &&
      !_.isEmpty(_.get(item, 'attributes.email')) &&
      !_.isEmpty(_.get(item, 'attributes.full_name'))
    ) {
      finalLabel = `${_.get(item, 'attributes.mobile_number') || ''} | ${_.get(
        item,
        'attributes.email'
      ) || ''} | ${_.get(item, 'attributes.full_name') || ''} `;
    }
    if (
      _.isEmpty(_.get(item, 'attributes.mobile_number')) &&
      !_.isEmpty(_.get(item, 'attributes.email')) &&
      !_.isEmpty(_.get(item, 'attributes.full_name'))
    ) {
      finalLabel = `${_.get(item, 'attributes.email') || ''} | ${_.get(
        item,
        'attributes.full_name'
      ) || ''} `;
    }
    if (
      !_.isEmpty(_.get(item, 'attributes.mobile_number')) &&
      _.isEmpty(_.get(item, 'attributes.email')) &&
      !_.isEmpty(_.get(item, 'attributes.full_name'))
    ) {
      finalLabel = `${_.get(item, 'attributes.mobile_number') || ''} | ${_.get(
        item,
        'attributes.full_name'
      ) || ''} `;
    }
    if (
      _.isEmpty(_.get(item, 'attributes.mobile_number')) &&
      !_.isEmpty(_.get(item, 'attributes.email')) &&
      _.isEmpty(_.get(item, 'attributes.full_name'))
    ) {
      finalLabel = `${_.get(item, 'attributes.email') || ''} `;
    }
    if (
      !_.isEmpty(_.get(item, 'attributes.mobile_number')) &&
      _.isEmpty(_.get(item, 'attributes.email')) &&
      _.isEmpty(_.get(item, 'attributes.full_name'))
    ) {
      finalLabel = `${_.get(item, 'attributes.mobile_number') || ''} `;
    }
    if (
      _.isEmpty(_.get(item, 'attributes.mobile_number')) &&
      _.isEmpty(_.get(item, 'attributes.email')) &&
      !_.isEmpty(_.get(item, 'attributes.full_name'))
    ) {
      finalLabel = `${_.get(item, 'attributes.full_name') || ''} `;
    }
    if (
      !_.isEmpty(_.get(item, 'attributes.mobile_number')) &&
      !_.isEmpty(_.get(item, 'attributes.email')) &&
      _.isEmpty(_.get(item, 'attributes.full_name'))
    ) {
      finalLabel = `${_.get(item, 'attributes.mobile_number') || ''} | ${_.get(
        item,
        'attributes.email'
      ) || ''} `;
    }
    return {
      label: finalLabel,
      value: _.get(item, 'id'),
      fullInfo: item,
    };
  });
};

const TaxpayerDropdown = ({ name, onChange, value, readOnly }) => {
  const dispatch = useDispatch();
  const list = useSelector(selectList);
  const options = [...formatOptions(list)];

  const findValue =
    options.find(item => +_.get(item, 'fullInfo.id') === +value) || '';

  useEffect(() => {
    dispatch(getTaxPayerList({ q: '' }));
  }, []);

  const handleChange = data => {
    onChange({
      target: {
        name,
        value: data ? data.value : '',
        label: data ? data.label : '',
      },
    });
  };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      getTaxPayerList({ q: inputValue }, response => {
        callback(formatOptions(_.get(response, 'data')));
      })
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span className="full-input text-uppercase">
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      placeholder="- Type to Search -"
      value={findValue}
      onChange={handleChange}
      defaultOptions=""
      loadOptions={loadOptionsDebounce}
      components={{
        IndicatorSeparator: () => null,
      }}
      isClearable
    />
  );
};

TaxpayerDropdown.defaultProps = {
  name: undefined,
  readOnly: undefined,
};

TaxpayerDropdown.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
};

export default TaxpayerDropdown;
